module.exports = __webpack_public_path__ + "img/logo-um-pf-ang.c1ff6b82.png";